import CircleDiagram from '@/components/circle-diagram/circle-diagram.vue'
import Loader from '@/components/loader/loader.vue'
import IcReadyStatus from '@/assets/svg/shift-statuses/ic-ready-status.svg?inline'
import IcReviewStatus from '@/assets/svg/shift-statuses/ic-review-status.svg?inline'
import IcDeliveryStatus from '@/assets/svg/shift-statuses/ic-delivery-status.svg?inline'
import IcOnthewayStatus from '@/assets/svg/shift-statuses/ic-ontheway-status.svg?inline'
import IcPauseStatus from '@/assets/svg/shift-statuses/ic-pause-status.svg?inline'
/**
 * !!! в названии должен быть статус, поэтому через _
 */
import IcGainStatus from '@/assets/svg/shift-statuses/ic-gain-status.svg?inline'
import { shiftStatuses } from '@/const'


export default {
  name: 'CourierRegionInfo',
  props: {
    dataShifts: {
      /**
       * {
            "couriers": {
              "in_fact": 0,
              "planned": 0,
              "required": 0
            },
            "couriers_by_statuses": {
              "ready": 0,
              "review": 0,
              "delivery": 0,
              "ontheway": 0,
              "pause": 0,
              "wait_check_bags": 0,
              "gain": 0
            }
          }
       */
      type: Object | null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CircleDiagram,
    Loader,
    IcReadyStatus,
    IcReviewStatus,
    IcDeliveryStatus,
    IcOnthewayStatus,
    IcPauseStatus,
    /**
     * !!! в названии должен быть статус, поэтому через _
     */
    IcGainStatus
  },
  static() {
    return {
      shiftStatuses,
      shiftStatusesOrder: [
        'ready',
        'review',
        'delivery',
        'ontheway',
        'pause',
        'gain'
      ]
    }
  },
  computed: {
    requiredRelations() {
      const { in_fact, required } = this.dataShifts.couriers
      return Math.round((in_fact / required) * 100)
    },
    statusesShow() {
      return this.shiftStatusesOrder.reduce((acc, status) => {
        if (this.dataShifts.couriers_by_statuses[status] !== 0) {
          return [...acc, status]
        }
        return acc
      }, [])
    }
  },
  methods: {
    getRelationText(controlValue, value) {
      const diff = controlValue - value
      if (diff < 0) {
        return `перебор ${Math.abs(diff)}`
      }
      if (diff > 0) {
        return `недобор ${diff}`
      }
      return ''
    }
  }
}